import { useToggleStore } from '@/store/toggle/toggle'
import { useUserStore } from '@/store/user/user'

import { VkAuthType } from '@/services/vk/types'

import { VkAuthService } from '@/services/vk'
import { authByVk } from '@/services/vk/callback'

export const useVkAuth = async (type: VkAuthType, container?: HTMLElement) => {
  const { VK_TOKEN } = useRuntimeConfig().public

  const userStore = useUserStore()
  const {
    featureToggle: { auth_by_vk_id_enabled },
  } = useToggleStore()

  if (!auth_by_vk_id_enabled || userStore.isAuthenticated) return

  const vkAuthService = VkAuthService.getInstance()

  await vkAuthService.init(VK_TOKEN, window.location.origin)

  if (type === VkAuthType.Button) {
    vkAuthService.initOneTap(authByVk, container)
  }

  if (type === VkAuthType.Window) {
    vkAuthService.initFloatingOneTap(authByVk)
  }
}
